const fileSize = size => {
  if (isNaN(size)) return size;

  if (size < 1024) {
    return `${size} B`;
  } else if (size > 1024 && size < 1048576) {
    return `${(size / 1024).toFixed(1)} KB`;
  } else if (size > 1048576) {
    return `${(size / 1048576).toFixed(1)} MB`;
  }
};

export default fileSize;
